import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { EquineService } from '../../../quote/equine/equine.service';

@Component({
  selector: 'app-equine-policy',
  templateUrl: './equine-policy.component.html',
  styleUrls: ['./equine-policy.component.css']
})
export class EquinePolicyComponent implements OnInit {
  quoteId: string;
  policyDetails: any = {};
  staticData: any = null;
  loading = true;
  isAdmin = false;
  isBroker = false;
  displayNewEmailView: boolean = false;
  email_id: string = '';
  displayEmailView: boolean = false;
  hasImportantNotes: boolean = false;
  totalImpNotes: number = 0;

  constructor(
    private equineService: EquineService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionSt: LocalStorageService
  ) {}

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }
    this.quoteId = this.route.snapshot.params.quote_id;
    this.equineService.getStaticData().subscribe(
      (res: any) => {
        if (res?.success && res?.result) {
          this.staticData = res.result;
        }
      }
    );
    if (this.quoteId) {
      this.equineService.getEquineData(this.quoteId).subscribe(
        (response: any) => {
          if (response.success && response.result) {
            this.policyDetails = response.result;
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }

  /** Navigate to quote flow for MTA (3) or Cancellation (4) */
  policyActions(type: number): void {
    if (!this.quoteId) return;
    this.router.navigate(['/equine', 'quote', this.quoteId, type]);
  }

  quoteDetailsUpdated(quotedata: any): void {
    this.policyDetails = quotedata;
  }

  getEmailView(email_id: string) {
    this.email_id = email_id;
    this.displayEmailView = true;
  }

  newEmailView() {
    this.displayNewEmailView = true;
  }

  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }

  onhasImportantNotesChange(event: boolean) {
    this.hasImportantNotes = event;
    const notes = this.policyDetails?.notes;
    this.totalImpNotes = Array.isArray(notes) ? notes.filter((n: any) => n.is_important == 1).length : 0;
  }
}
